/**
 * Sanitize text input - trim whitespace and normalize
 */
export const sanitizeText = (text) => {
  if (!text) return '';
  return text.trim().replace(/\s+/g, ' '); // Also collapse multiple spaces
};

/**
 * Reduce whatever was typed, pasted or autofilled into the number box to the
 * number without its country code, digits only (e.g. "+91 98765 43210" -> "9876543210")
 */
export const tidyPhoneNumber = (number, countryCode) => {
  const value = String(number || '').trim();
  const code = String(countryCode || '').replace(/\D/g, '');
  const digits = value.replace(/\D/g, '');

  // Full international number for the selected country
  if (value.startsWith('+') && code && digits.length > code.length && digits.startsWith(code)) {
    return digits.slice(code.length);
  }
  if (code === '91') {
    // Autofill often gives the full number without the plus, or with a leading 0
    if (digits.length === 12 && digits.startsWith('91')) return digits.slice(2);
    if (digits.length === 11 && digits.startsWith('0')) return digits.slice(1);
  }
  return digits;
};

/**
 * Join a country code and a mobile number into E.164 format (e.g. +919876543210)
 * @returns {{phoneNumber: string}|{error: string}}
 */
export const buildPhoneNumber = (countryCode, number) => {
  const code = String(countryCode || '').replace(/\D/g, '');
  const digits = tidyPhoneNumber(number, code);

  if (!digits) return { error: 'Please enter your mobile number' };
  if (!code) return { error: 'Please enter your country code (91 for India)' };

  if (code === '91') {
    if (!/^[6-9]\d{9}$/.test(digits)) return { error: 'Please enter a valid 10-digit mobile number' };
  } else if (digits.length < 4 || code.length + digits.length > 15) {
    return { error: 'Please check your mobile number and country code' };
  }

  return { phoneNumber: `+${code}${digits}` };
};

/**
 * Validate and sanitize form data before submission
 * Sanitizes all string fields, preserves booleans and numbers
 */
export const sanitizeFormData = (formData) => {
  const sanitized = {};
  Object.keys(formData).forEach(key => {
    sanitized[key] = typeof formData[key] === 'string'
      ? sanitizeText(formData[key])
      : formData[key];
  });
  return sanitized;
};